
import { Vue, Component, Watch } from "vue-property-decorator";
import debounce from "lodash/debounce";
@Component
export default class Index extends Vue {
  public name: string = "c-index";
  code: string = "";
  answer: string = "";
  showBox: boolean = false;
  stock_list: GAPI.stock[] = [];
  go() {
    if (!this.code) {
      this.$Message.warning("请先输入股票代码");
      return;
    }
    // this.$rouer.push('/ccass/'+this.code)
    if (this.$route.name != "home") {
      //console.log(this.$route.name)
      this.$router.push("/" + this.$route.name + "/" + this.code);
    } else {
      this.$router.push("/xccass/" + this.code);
    }
  }
  goto(code: string): void {
    this.$router.push("/xccass/" + code);
  }
  @Watch("code")
  get_search() {
    const self = this;
    debounce(async function() {
      if (!self.code) {
        self.showBox = false;
        self.answer = "请输入股票代码";
        return;
      }
      self.answer = "Thinking ... ";
      const {
        data: { result }
      } = await self.$api.GetStockList(self.code);
      if (result) {
        self.stock_list = result.stockList;
        self.showBox = true;
      } else {
        self.stock_list = [];
        self.showBox = false;
      }
    }, 700)();
  }
  mounted() {}
  beforeDestroy() {}
}
